<template>
    <div class="table-responsive">
        <table class="table table-hover table-borderless mb-0 product-table">
            <thead>
                <tr class="table-light text-center">
                    <th class="py-3">选中</th>
                    <th class="py-3">商品</th>
                    <th class="py-3">图片</th>
                    <th class="py-3">单价</th>
                    <th class="py-3">数量</th>
                    <th class="py-3">小计</th>
                    <th class="py-3">操作</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in products" :key="item.id" class="text-center align-middle border-bottom border-light">
                    <td class="py-3">
                        <input type="checkbox" v-model="item.checked" class="form-check-input">
                    </td>
                    <td class="py-3 fw-medium">{{ item.name }}</td>
                    <td class="py-3">
                        <img :src="item.imgUrl" :alt="item.name" width="50" height="50" 
                             class="rounded" style="object-fit: cover;">
                    </td>
                    <td class="py-3">¥{{ item.price }}</td>
                    <td class="py-3">
                        <div class="btn-group btn-group-sm" role="group">
                            <button class="btn btn-outline-secondary" @click="decreaseCount(item)">-</button>
                            <button class="btn btn-outline-secondary" disabled>{{ item.count }}</button>
                            <button class="btn btn-outline-primary" @click="increaseCount(item)">+</button>
                        </div>
                    </td>
                    <td class="py-3 fw-bold">¥{{ (item.count * item.price).toFixed(2) }}</td>
                    <td class="py-3">
                        <button class="btn btn-outline-danger btn-sm" @click="deleteItem(item.id)">
                            <i class="bi bi-trash"></i> 删除
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        
        <div v-if="products.length === 0" class="text-center py-5">
            <i class="bi bi-inbox display-4 text-muted"></i>
            <p class="text-muted mt-3">该分类暂无商品</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        products: {
            type: Array,
            required: true
        }
    },
    methods: {
        increaseCount(item) {
            item.count++;
            this.$emit('update-products', [...this.products]);
        },
        decreaseCount(item) {
            if (item.count > 0) {
                item.count--;
                this.$emit('update-products', [...this.products]);
            }
        },
        deleteItem(itemId) {
            const updatedProducts = this.products.filter(item => item.id !== itemId);
            this.$emit('update-products', updatedProducts);
        }
    }
}
</script>

<style scoped>
.product-table {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    background-color: white;
}

.btn-group .btn:disabled {
    background-color: #f8f9fa;
    color: #495057;
}

@media (max-width: 768px) {
    .product-table {
        font-size: 0.875rem;
    }
    
    .btn-group .btn {
        padding: 0.25rem 0.5rem;
        font-size: 0.75rem;
    }
}
</style>